/* RCS — October '26 refresh behaviour (hero slider, carousels, footer accordions, drawers). */
(function () {
  'use strict';

  function initHero(root) {
    var slides = root.querySelectorAll('.rcs-hero__slide');
    var bars = root.querySelectorAll('.rcs-hero__bar');
    var count = root.querySelector('.rcs-hero__count');
    if (slides.length < 2) return;
    var index = 0;
    var delay = (parseInt(root.dataset.speed, 10) || 6) * 1000;
    var timer = null;

    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function go(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) {
        var active = n === index;
        s.classList.toggle('is-active', active);
        s.setAttribute('aria-hidden', active ? 'false' : 'true');
        var v = s.querySelector('video');
        if (v) { if (active) { v.play && v.play().catch(function () {}); } else { v.pause && v.pause(); } }
      });
      bars.forEach(function (b, n) {
        b.classList.toggle('is-active', n === index);
        b.setAttribute('aria-current', n === index ? 'true' : 'false');
      });
      if (count) count.textContent = pad(index + 1) + ' / ' + pad(slides.length);
    }
    function start() {
      if (root.dataset.autoplay !== 'true') return;
      stop();
      timer = setInterval(function () { go(index + 1); }, delay);
    }
    function stop() { if (timer) clearInterval(timer); timer = null; }

    bars.forEach(function (b, n) { b.addEventListener('click', function () { go(n); start(); }); });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { go(index + (dx < 0 ? 1 : -1)); start(); }
      x0 = null;
    });

    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:block:select', function (e) {
        var el = root.querySelector('[data-block-id="' + e.detail.blockId + '"]');
        if (el) { stop(); go(Array.prototype.indexOf.call(slides, el)); }
      });
    }

    go(0);
    start();
  }

  function initTrack(root) {
    var track = root.querySelector('.rcs-track');
    if (!track) return;
    var prev = root.querySelectorAll('[data-rcs-prev]');
    var next = root.querySelectorAll('[data-rcs-next]');
    function step() { return track.clientWidth * 0.9; }
    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.forEach(function (b) { b.disabled = track.scrollLeft <= 2; });
      next.forEach(function (b) { b.disabled = track.scrollLeft >= max; });
    }
    prev.forEach(function (b) { b.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); }); });
    next.forEach(function (b) { b.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initFooter(root) {
    root.querySelectorAll('.rcs-footer__col-title').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (window.matchMedia('(min-width: 990px)').matches) return;
        var col = btn.closest('.rcs-footer__col');
        var open = col.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  function initHeader(root) {
    var toggle = root.querySelector('[data-rcs-search-toggle]');
    var panel = root.querySelector('.rcs-header__mobile-search');
    if (toggle && panel) {
      toggle.addEventListener('click', function () {
        var open = panel.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) { var i = panel.querySelector('input'); if (i) i.focus(); }
      });
    }

    // The RCS header replaces Impulse's header section, so wire up Impulse's
    // nav + cart drawers here (normally done by theme.HeaderSection).
    if (root.dataset.drawersReady) return;
    root.dataset.drawersReady = 'true';
    if (!window.theme || !theme.Drawers) return;
    // Same as the cart drawer: inside the sticky header section (z-index 25) the nav drawer
    // sits under Impulse's page dimmer, so taps hit the dimmer and close the menu.
    var section = root.closest('.shopify-section') || root;
    var nav = section.querySelector('#NavDrawer');
    if (nav) {
      document.querySelectorAll('body > #NavDrawer').forEach(function (d) { if (d !== nav) d.remove(); });
      document.body.appendChild(nav);
    }
    if (document.getElementById('NavDrawer')) {
      theme.NavDrawer = new theme.Drawers('NavDrawer', 'nav');
      if (theme.collapsibles) theme.collapsibles.init(document.getElementById('NavDrawer'));
    }
    if (theme.settings && theme.settings.cartType === 'drawer' && theme.CartDrawer &&
        document.getElementById('CartDrawer') && !document.body.classList.contains('template-cart')) {
      new theme.CartDrawer();
    }
  }

  /* ---------- Product page ---------- */
  function initProduct(root) {
    if (root.dataset.rcsReady) return;
    root.dataset.rcsReady = 'true';
    var jsonEl = root.querySelector('[data-rcs-product-json]');
    if (!jsonEl) return;
    var data = JSON.parse(jsonEl.textContent);
    var variants = data.variants;
    var form = root.querySelector('#RcsProductForm');
    var idInput = root.querySelector('[data-rcs-variant-id]');
    var addBtn = root.querySelector('[data-rcs-add]');
    var addLabel = root.querySelector('[data-rcs-add-label]');
    var priceEl = root.querySelector('[data-rcs-price]');
    var instEl = root.querySelector('[data-rcs-instalments]');
    var stockEl = root.querySelector('[data-rcs-stock]');
    var stockText = root.querySelector('[data-rcs-stock-text]');
    var sizeError = root.querySelector('[data-rcs-size-error]');
    var formError = root.querySelector('[data-rcs-form-error]');
    var sizeIndex = parseInt(root.dataset.sizeIndex, 10);
    var lowStock = parseInt(root.dataset.lowStock, 10) || 0;
    var optionCount = variants.length ? variants[0].options.length : 0;
    var selected = [];

    // initial selection from DOM
    for (var i = 0; i < optionCount; i++) selected[i] = null;
    root.querySelectorAll('[data-rcs-fixed-option]').forEach(function (el) { selected[+el.dataset.rcsFixedOption] = el.value; });
    root.querySelectorAll('[data-rcs-option]').forEach(function (fs) {
      var idx = +fs.dataset.rcsOption;
      var sel = fs.querySelector('.is-selected');
      if (sel) selected[idx] = sel.dataset.value;
    });

    function matches(v, sel, skip) {
      for (var i = 0; i < sel.length; i++) {
        if (i === skip) continue;
        if (sel[i] !== null && v.options[i] !== sel[i]) return false;
      }
      return true;
    }
    function current() {
      for (var i = 0; i < selected.length; i++) if (selected[i] === null) return null;
      for (var j = 0; j < variants.length; j++) if (matches(variants[j], selected, -1)) return variants[j];
      return null;
    }
    function variantFor(idx, value) {
      var sel = selected.slice(); sel[idx] = value;
      for (var j = 0; j < variants.length; j++) {
        var v = variants[j]; var ok = true;
        for (var i = 0; i < sel.length; i++) { if (sel[i] !== null && v.options[i] !== sel[i]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }
    function money(cents) {
      if (window.theme && theme.Currency && theme.Currency.formatMoney) return theme.Currency.formatMoney(cents, data.money_format);
      return 'R ' + (cents / 100).toFixed(2);
    }

    function render() {
      var v = current();
      // option availability
      root.querySelectorAll('[data-rcs-option]').forEach(function (fs) {
        var idx = +fs.dataset.rcsOption;
        fs.querySelectorAll('[data-value]').forEach(function (btn) {
          var cand = variantFor(idx, btn.dataset.value);
          var unavailable = !cand || !cand.available;
          btn.classList.toggle('is-unavailable', unavailable);
          btn.classList.toggle('is-selected', selected[idx] === btn.dataset.value);
          btn.setAttribute('aria-pressed', selected[idx] === btn.dataset.value ? 'true' : 'false');
          if (fs.dataset.optionKind === 'size') btn.disabled = unavailable;
        });
      });

      var shown = v || variantFor(-1, null) || variants[0];
      if (priceEl && shown) {
        priceEl.innerHTML = shown.compare > shown.price
          ? '<span class="rcs-price--sale">' + shown.price_fmt + '</span> <s class="rcs-pdp__was">' + shown.compare_fmt + '</s>'
          : '<span>' + shown.price_fmt + '</span>';
      }
      if (instEl && shown) {
        var parts = parseInt(instEl.dataset.parts, 10) || 4;
        instEl.textContent = instEl.dataset.template.replace('[amount]', money(Math.round(shown.price / parts)));
      }

      idInput.value = v ? v.id : '';
      if (addBtn) {
        if (v && !v.available) { addBtn.disabled = true; addLabel.textContent = 'Sold out'; }
        else { addBtn.disabled = false; addLabel.textContent = 'Add to bag'; }
      }

      if (stockEl) {
        if (v && v.available && v.qty !== null && v.qty > 0 && v.qty <= lowStock) {
          stockText.textContent = 'Only ' + v.qty + ' left' + (sizeIndex >= 0 ? ' in ' + v.options[sizeIndex] : '') + ' — order soon';
          stockEl.hidden = false;
        } else { stockEl.hidden = true; }
      }

      if (v) {
        if (sizeError) sizeError.hidden = true;
        if (window.history && history.replaceState) {
          var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
          history.replaceState({}, '', url.toString());
        }
        if (v.media) showMedia(v.media);
      }
      renderSheet();
    }

    root.querySelectorAll('[data-rcs-option]').forEach(function (fs) {
      var idx = +fs.dataset.rcsOption;
      fs.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-value]');
        if (!btn || btn.disabled) return;
        selected[idx] = btn.dataset.value;
        // keep the size valid when switching other options
        if (idx !== sizeIndex && sizeIndex >= 0 && selected[sizeIndex] !== null) {
          var cand = variantFor(sizeIndex, selected[sizeIndex]);
          if (!cand || !cand.available) selected[sizeIndex] = null;
        }
        render();
      });
    });

    /* gallery (mobile swipe counter + progress) */
    var gallery = root.querySelector('[data-rcs-gallery]');
    var counter = root.querySelector('[data-rcs-counter]');
    var progress = root.querySelector('[data-rcs-progress]');
    var slides = gallery ? gallery.children : [];
    function onScroll() {
      if (!slides.length) return;
      var w = slides[0].getBoundingClientRect().width + 8;
      var i = Math.min(slides.length - 1, Math.round(gallery.scrollLeft / w));
      if (counter) counter.textContent = (i + 1) + ' / ' + slides.length;
      if (progress) { progress.style.width = (100 / slides.length) + '%'; progress.style.transform = 'translateX(' + (i * 100) + '%)'; }
    }
    if (gallery) gallery.addEventListener('scroll', onScroll, { passive: true });
    function showMedia(id) {
      var el = gallery && gallery.querySelector('[data-media-id="' + id + '"]');
      if (!el) return;
      if (window.matchMedia('(max-width: 989px)').matches) gallery.scrollTo({ left: el.offsetLeft - gallery.offsetLeft - 16, behavior: 'smooth' });
    }

    /* size sheet */
    var sheet = root.querySelector('[data-rcs-sheet]');
    var sheetList = root.querySelector('[data-rcs-sheet-list]');
    var sheetAdd = root.querySelector('[data-rcs-sheet-add]');
    var sheetPrice = root.querySelector('[data-rcs-sheet-price]');
    function renderSheet() {
      if (!sheet || sizeIndex < 0) return;
      var html = '';
      root.querySelectorAll('[data-option-kind="size"] [data-value]').forEach(function (btn) {
        var value = btn.dataset.value;
        var cand = variantFor(sizeIndex, value);
        var unavailable = !cand || !cand.available;
        var note = '';
        if (unavailable) note = 'Sold out';
        else if (cand.qty !== null && cand.qty > 0 && cand.qty <= lowStock) note = 'Only ' + cand.qty + ' left';
        var isSel = selected[sizeIndex] === value;
        html += '<button type="button" class="rcs-sheet__row' + (isSel ? ' is-selected' : '') + (unavailable ? ' is-unavailable' : '') + '" data-sheet-value="' + value.replace(/"/g, '&quot;') + '"' + (unavailable ? ' disabled' : '') + '><span>' + value + '</span>' + (note ? '<span class="rcs-caption">' + note + '</span>' : '') + '</button>';
      });
      sheetList.innerHTML = html;
      var v = current();
      sheetAdd.disabled = !(v && v.available);
      sheetAdd.textContent = v ? 'Add to bag · ' + v.options[sizeIndex] : 'Add to bag';
      var shown = v || variantFor(-1, null);
      if (sheetPrice && shown) sheetPrice.textContent = shown.price_fmt;
    }
    function openSheet() { if (!sheet) return; renderSheet(); sheet.hidden = false; document.documentElement.classList.add('rcs-lock'); requestAnimationFrame(function () { sheet.classList.add('is-open'); }); }
    function closeSheet() { if (!sheet) return; sheet.classList.remove('is-open'); document.documentElement.classList.remove('rcs-lock'); setTimeout(function () { sheet.hidden = true; }, 250); }
    if (sheet) {
      sheet.querySelectorAll('[data-rcs-sheet-close]').forEach(function (b) { b.addEventListener('click', closeSheet); });
      sheetList.addEventListener('click', function (e) {
        var row = e.target.closest('[data-sheet-value]');
        if (!row || row.disabled) return;
        selected[sizeIndex] = row.dataset.sheetValue;
        render();
      });
      sheetAdd.addEventListener('click', function () { closeSheet(); submit(); });
    }

    /* add to bag */
    function showError(msg) { if (!formError) return; formError.textContent = msg; formError.hidden = !msg; }
    function submit() {
      showError('');
      var v = current();
      if (!v) {
        if (sheet && window.matchMedia('(max-width: 989px)').matches) { openSheet(); return; }
        if (sizeError) { sizeError.hidden = false; sizeError.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
        return;
      }
      if (root.dataset.cartType !== 'drawer') { form.submit(); return; }
      addBtn.disabled = true; addBtn.classList.add('is-loading');
      fetch((window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
        .then(function (res) {
          if (!res.ok) { showError(res.json.description || res.json.message || 'Could not add to bag.'); return; }
          form.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true, detail: { product: res.json, addToCartBtn: addBtn } }));
        })
        .catch(function () { form.submit(); })
        .finally(function () { addBtn.disabled = false; addBtn.classList.remove('is-loading'); render(); });
    }
    form.addEventListener('submit', function (e) { e.preventDefault(); submit(); });

    render();
    onScroll();
  }

  /* ---------- Collection page (filters, sort, load more, drawer) ---------- */
  function initCollection(root) {
    if (root.dataset.rcsReady) return;
    root.dataset.rcsReady = 'true';
    var sectionId = root.dataset.sectionId;
    var form = root.querySelector('[data-rcs-filters]');
    var sortInput = form.querySelector('[data-rcs-sort-input]');
    var pending = null;

    function withSection(url) { return url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + sectionId; }

    function setupRanges(scope) {
      scope.querySelectorAll('[data-rcs-range]').forEach(function (r) {
        var min = r.querySelector('[data-rcs-range-min]');
        var max = r.querySelector('[data-rcs-range-max]');
        var active = r.querySelector('[data-rcs-range-active]');
        var minL = r.querySelector('[data-rcs-range-min-label]');
        var maxL = r.querySelector('[data-rcs-range-max-label]');
        var top = parseFloat(r.dataset.max) || 1;
        function paint(e) {
          var a = parseFloat(min.value), b = parseFloat(max.value);
          if (a > b) { if (e && e.target === min) { min.value = b; a = b; } else { max.value = a; b = a; } }
          active.style.left = (a / top * 100) + '%';
          active.style.right = (100 - b / top * 100) + '%';
          minL.textContent = 'R ' + a; maxL.textContent = 'R ' + b;
        }
        min.addEventListener('input', paint); max.addEventListener('input', paint);
        paint();
      });
    }

    function params() {
      var fd = new FormData(form);
      var p = new URLSearchParams();
      fd.forEach(function (v, k) { if (k !== 'rcs_sort_m' && v !== '') p.append(k, v); });
      form.querySelectorAll('[data-rcs-range]').forEach(function (r) {
        var min = r.querySelector('[data-rcs-range-min]'), max = r.querySelector('[data-rcs-range-max]');
        if (parseFloat(min.value) <= 0) p.delete(min.name);
        if (parseFloat(max.value) >= parseFloat(r.dataset.max)) p.delete(max.name);
      });
      return p;
    }

    function swap(html, url, push) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-rcs-collection]');
      if (!fresh) { window.location.href = url; return; }
      // keep open/closed state of filter groups
      var open = {};
      root.querySelectorAll('[data-rcs-filter-groups] details').forEach(function (d) { open[d.dataset.groupId] = d.open; });
      var groups = root.querySelector('[data-rcs-filter-groups]');
      groups.innerHTML = fresh.querySelector('[data-rcs-filter-groups]').innerHTML;
      groups.querySelectorAll('details').forEach(function (d) { if (d.dataset.groupId in open) d.open = open[d.dataset.groupId]; });
      root.querySelector('[data-rcs-results]').innerHTML = fresh.querySelector('[data-rcs-results]').innerHTML;
      ['[data-rcs-count]', '[data-rcs-sort-label]', '[data-rcs-active-count-text]'].forEach(function (sel) {
        var src = fresh.querySelector(sel);
        if (src) root.querySelectorAll(sel).forEach(function (el) { el.textContent = src.textContent; });
      });
      var badge = root.querySelector('[data-rcs-active-count]'), srcBadge = fresh.querySelector('[data-rcs-active-count]');
      if (badge && srcBadge) { badge.textContent = srcBadge.textContent; badge.hidden = srcBadge.hidden; }
      var foot = root.querySelector('.rcs-plp__drawer-foot a'), srcFoot = fresh.querySelector('.rcs-plp__drawer-foot a');
      if (foot && srcFoot) foot.href = srcFoot.getAttribute('href');
      setupRanges(groups);
      if (push) history.pushState({ rcs: true }, '', url);
      root.classList.remove('is-loading');
    }

    function load(url, push) {
      if (pending) pending.abort();
      pending = window.AbortController ? new AbortController() : null;
      root.classList.add('is-loading');
      fetch(withSection(url), pending ? { signal: pending.signal } : {})
        .then(function (r) { return r.text(); })
        .then(function (html) { swap(html, url, push !== false); })
        .catch(function (e) { if (!e || e.name !== 'AbortError') window.location.href = url; });
    }

    function apply() {
      var qs = params().toString();
      load(window.location.pathname + (qs ? '?' + qs : ''));
    }

    var timer = null;
    form.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches('[data-rcs-sort-radio]')) { sortInput.value = t.value; }
      if (t.type === 'checkbox') { var lab = t.closest('label'); if (lab) lab.classList.toggle('is-active', t.checked); }
      clearTimeout(timer); timer = setTimeout(apply, 60);
    });
    var sortSelect = root.querySelector('[data-rcs-sort]');
    if (sortSelect) sortSelect.addEventListener('change', function () { sortInput.value = sortSelect.value; apply(); });

    root.addEventListener('click', function (e) {
      var link = e.target.closest('[data-rcs-ajax-link]');
      if (link) { e.preventDefault(); load(link.getAttribute('href')); return; }

      var more = e.target.closest('[data-rcs-load-more]');
      if (more) {
        e.preventDefault();
        more.classList.add('is-loading'); more.textContent = 'Loading…';
        fetch(withSection(more.getAttribute('href'))).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var grid = root.querySelector('[data-rcs-grid]');
          var freshGrid = doc.querySelector('[data-rcs-grid]');
          if (grid && freshGrid) Array.prototype.slice.call(freshGrid.children).forEach(function (c) { if (!c.classList.contains('rcs-plp__promo')) grid.appendChild(c); });
          var pag = root.querySelector('[data-rcs-pagination]'), freshPag = doc.querySelector('[data-rcs-pagination]');
          if (pag && freshPag) pag.innerHTML = freshPag.innerHTML;
        }).catch(function () { window.location.href = more.getAttribute('href'); });
        return;
      }

      var showMore = e.target.closest('[data-rcs-more]');
      if (showMore) {
        var list = showMore.previousElementSibling;
        var collapsed = list.classList.toggle('is-collapsed');
        showMore.textContent = collapsed ? 'Show more' : 'Show less';
        return;
      }

      var toggle = e.target.closest('[data-rcs-toggle-filters]');
      if (toggle) {
        var hidden = root.classList.toggle('rcs-plp--hide-filters');
        toggle.setAttribute('aria-expanded', hidden ? 'false' : 'true');
        root.querySelector('[data-rcs-toggle-label]').textContent = hidden ? 'Show filters' : 'Hide filters';
        return;
      }

      if (e.target.closest('[data-rcs-open-drawer]')) {
        root.classList.add('is-drawer-open'); document.documentElement.classList.add('rcs-lock'); return;
      }
      if (e.target.closest('[data-rcs-close-drawer]')) {
        root.classList.remove('is-drawer-open'); document.documentElement.classList.remove('rcs-lock');
        var results = root.querySelector('[data-rcs-body]');
        if (results && window.scrollY > results.offsetTop) window.scrollTo({ top: results.offsetTop - 140, behavior: 'smooth' });
      }
    });

    window.addEventListener('popstate', function (e) { if (e.state && e.state.rcs) load(window.location.href, false); });
    document.addEventListener('keyup', function (e) { if (e.key === 'Escape') { root.classList.remove('is-drawer-open'); document.documentElement.classList.remove('rcs-lock'); } });
    setupRanges(root);
  }

  /* ---------- Section rendering fetch (recommendations) ---------- */
  function initRecommendations(root) {
    if (root.dataset.loaded) return;
    root.dataset.loaded = 'true';
    fetch(root.dataset.rcsRecommendationsUrl).then(function (r) { return r.text(); }).then(function (html) {
      var div = document.createElement('div'); div.innerHTML = html;
      var inner = div.querySelector('[data-rcs-recommendations-url]');
      if (inner && inner.querySelector('.rcs-card')) {
        root.innerHTML = inner.innerHTML;
        var carousel = root.closest('[data-rcs-carousel]');
        if (carousel) initTrack(carousel);
      }
      else if (!root.querySelector('.rcs-card')) { root.closest('section').hidden = true; }
    }).catch(function () {});
  }

  /* Cart page: change quantities in place, re-render the section, keep Impulse's drawer/count in sync */
  function initCart(root) {
    if (root.dataset.rcsReady) return;
    root.dataset.rcsReady = 'true';
    var sectionId = root.dataset.sectionId;
    var busy = false;

    function change(line, qty) {
      if (busy) return;
      busy = true;
      root.classList.add('is-loading');
      fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/change.js' : '/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: Math.max(0, qty), sections: sectionId })
      }).then(function (r) { return r.json(); }).then(function (data) {
        var html = data.sections && data.sections[sectionId];
        if (!html) { window.location.reload(); return; }
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-rcs-cart]');
        if (fresh) root.innerHTML = fresh.innerHTML;
        document.dispatchEvent(new CustomEvent('cart:build'));
      }).catch(function () { window.location.reload(); }).then(function () {
        busy = false;
        root.classList.remove('is-loading');
      });
    }

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-rcs-qty]');
      if (btn) {
        e.preventDefault();
        var item = btn.closest('[data-rcs-line]');
        change(parseInt(item.dataset.rcsLine, 10), parseInt(btn.dataset.rcsQty, 10));
        return;
      }
      var checkout = e.target.closest('[data-rcs-checkout]');
      var terms = root.querySelector('[data-rcs-terms]');
      if (checkout && terms && !terms.checked) {
        e.preventDefault();
        var err = root.querySelector('[data-rcs-terms-error]');
        if (err) err.hidden = false;
        terms.focus();
      }
    });
    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-rcs-qty-input]')) {
        var item = e.target.closest('[data-rcs-line]');
        change(parseInt(item.dataset.rcsLine, 10), parseInt(e.target.value, 10) || 0);
      } else if (e.target.matches('[data-rcs-terms]') && e.target.checked) {
        var err = root.querySelector('[data-rcs-terms-error]');
        if (err) err.hidden = true;
      }
    });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.matches('[data-rcs-qty-input]')) { e.preventDefault(); e.target.blur(); }
    });
  }

  /* Cart drawer: Impulse's CartForm rebuilds it; this adds remove, the title count and an inline terms error */
  function initBag(root) {
    if (root.dataset.rcsReady) return;
    root.dataset.rcsReady = 'true';
    // The sticky header section (z-index 25) would trap the drawer under Impulse's page dimmer.
    document.querySelectorAll('body > #CartDrawer').forEach(function (d) { if (d !== root) d.remove(); });
    if (root.parentElement !== document.body) document.body.appendChild(root);
    var products = root.querySelector('[data-products]');
    var countEl = root.querySelector('[data-rcs-bag-count]');
    var terms = root.querySelector('[data-rcs-bag-terms]');
    var termsError = root.querySelector('[data-rcs-bag-terms-error]');

    function syncCount() {
      var items = products && products.querySelector('.cart__items');
      var count = items ? parseInt(items.dataset.count, 10) || 0 : 0;
      if (countEl) countEl.textContent = count > 0 ? '(' + count + ')' : '';
      root.classList.toggle('is-empty', count === 0);
    }
    if (products) new MutationObserver(syncCount).observe(products, { childList: true });

    root.addEventListener('click', function (e) {
      var remove = e.target.closest('[data-rcs-bag-remove]');
      if (!remove) return;
      e.preventDefault();
      var item = remove.closest('.rcs-bag__item');
      if (item) item.classList.add('is-removing');
      fetch(((window.theme && theme.routes && theme.routes.cartChange) || '/cart/change.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: remove.dataset.rcsBagRemove, quantity: 0 })
      }).then(function (r) { return r.json(); }).then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      }).catch(function () { window.location.href = remove.href; });
    });

    // Runs before Impulse's own submit handler (which would alert()) when terms aren't ticked.
    document.addEventListener('submit', function (e) {
      if (e.target !== root.querySelector('form') || !terms || terms.checked) return;
      e.preventDefault();
      e.stopPropagation();
      if (termsError) termsError.hidden = false;
      terms.focus();
    }, true);
    if (terms) terms.addEventListener('change', function () { if (terms.checked && termsError) termsError.hidden = true; });
  }

  /* Search results: load more appends products and other results */
  function initSearch(root) {
    if (root.dataset.rcsReady) return;
    root.dataset.rcsReady = 'true';
    var sectionId = root.dataset.sectionId;
    root.addEventListener('click', function (e) {
      var more = e.target.closest('[data-rcs-load-more]');
      if (!more) return;
      e.preventDefault();
      var href = more.getAttribute('href');
      more.classList.add('is-loading'); more.textContent = 'Loading…';
      fetch(href + (href.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + sectionId).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        [['[data-rcs-grid]', '[data-rcs-grid]'], ['[data-rcs-other] ul', '[data-rcs-other] ul']].forEach(function (pair) {
          var target = root.querySelector(pair[0]), src = doc.querySelector(pair[1]);
          if (src && target) Array.prototype.slice.call(src.children).forEach(function (c) { target.appendChild(c); });
        });
        var pag = root.querySelector('[data-rcs-pagination]'), freshPag = doc.querySelector('[data-rcs-pagination]');
        if (pag && freshPag) pag.innerHTML = freshPag.innerHTML;
        if (window.WishEngineinit) { try { window.WishEngineinit(); } catch (err) {} }
      }).catch(function () { window.location.href = href; });
    });
  }

  /* Size guide: brand > category > chart tabs. ?brand=nike&cat=men preselects. */
  function initSizeGuide(root) {
    if (root.dataset.rcsReady) return;
    root.dataset.rcsReady = 'true';

    function select(buttons, attr, value, panels, panelAttr) {
      buttons.forEach(function (b) {
        var on = b.getAttribute(attr) === value;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function (p) { p.hidden = p.getAttribute(panelAttr) !== value; });
    }
    function children(scope, sel) {
      return Array.prototype.filter.call(scope.querySelectorAll(sel), function (el) { return el.closest('[data-rcs-size-guide]') === root; });
    }
    function direct(scope, sel) {
      return Array.prototype.filter.call(scope.querySelectorAll(sel), function (el) { return el.parentElement === scope || el.parentElement.parentElement === scope; });
    }

    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-rcs-sg-brand]');
      if (b) {
        select(children(root, '[data-rcs-sg-brand]'), 'data-rcs-sg-brand', b.dataset.rcsSgBrand, children(root, '[data-rcs-sg-brand-panel]'), 'data-rcs-sg-brand-panel');
        return;
      }
      var c = e.target.closest('[data-rcs-sg-cat]');
      if (c) {
        var bp = c.closest('[data-rcs-sg-brand-panel]');
        select(direct(bp, '[data-rcs-sg-cat]'), 'data-rcs-sg-cat', c.dataset.rcsSgCat, direct(bp, '[data-rcs-sg-cat-panel]'), 'data-rcs-sg-cat-panel');
        return;
      }
      var ch = e.target.closest('[data-rcs-sg-chart]');
      if (ch) {
        var cp = ch.closest('[data-rcs-sg-cat-panel]');
        select(Array.prototype.slice.call(cp.querySelectorAll('[data-rcs-sg-chart]')), 'data-rcs-sg-chart', ch.dataset.rcsSgChart, Array.prototype.slice.call(cp.querySelectorAll('[data-rcs-sg-chart-panel]')), 'data-rcs-sg-chart-panel');
      }
    });

    var params = new URLSearchParams(window.location.search);
    var brand = params.get('brand'), cat = params.get('cat');
    if (brand) {
      var bb = root.querySelector('[data-rcs-sg-brand="' + brand.toLowerCase() + '"]');
      if (bb) bb.click();
      if (cat) {
        var panel = root.querySelector('[data-rcs-sg-brand-panel="' + brand.toLowerCase() + '"]');
        var cb = panel && panel.querySelector('[data-rcs-sg-cat="' + cat.toLowerCase() + '"]');
        if (cb) cb.click();
      }
    }
  }

  /* Addresses: Impulse toggles the forms; bring the one that opened into view */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('.rcs-acct .address-new-toggle, .rcs-acct .address-edit-toggle');
    if (!t) return;
    setTimeout(function () {
      var id = t.classList.contains('address-new-toggle') ? 'AddressNewForm' : 'EditAddress_' + t.dataset.formId;
      var form = document.getElementById(id);
      if (form && !form.classList.contains('hide')) {
        form.scrollIntoView({ behavior: 'smooth', block: 'start' });
        var first = form.querySelector('input:not([type=hidden]):not([type=checkbox])');
        if (first) first.focus({ preventScroll: true });
      }
    }, 0);
  });

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-rcs-hero]').forEach(initHero);
    scope.querySelectorAll('[data-rcs-carousel]').forEach(initTrack);
    scope.querySelectorAll('[data-rcs-footer]').forEach(initFooter);
    scope.querySelectorAll('[data-rcs-header]').forEach(initHeader);
    scope.querySelectorAll('[data-rcs-product]').forEach(initProduct);
    scope.querySelectorAll('[data-rcs-collection]').forEach(initCollection);
    scope.querySelectorAll('[data-rcs-recommendations-url]').forEach(initRecommendations);
    scope.querySelectorAll('[data-rcs-cart]').forEach(initCart);
    scope.querySelectorAll('[data-rcs-bag]').forEach(initBag);
    scope.querySelectorAll('[data-rcs-search]').forEach(initSearch);
    scope.querySelectorAll('[data-rcs-size-guide]').forEach(initSizeGuide);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
